const idRegex = /\[\d+]/gi;

export const getIsDirtyPrescription = (
  dirtyFields:
    | {
        [key: string]: boolean;
      }
    | undefined,
  index: number,
  isPm?: boolean | undefined,
  isDecision?: boolean | undefined,
  modified?:
    | {
        [key: string]: boolean;
      }
    | undefined,
) => {
  if (!dirtyFields || Object.keys(dirtyFields).length === 0) {
    return {
      wasEditFiled: false,
      wasEditWithoutViolationsFixed: false,
      hasChangesOnlyInBlackList: false,
    };
  }

  let fields: string[] = fieldsKnm;

  if (isPm) {
    fields = fieldsPm;
  }

  if (isDecision) {
    fields = fieldsDecision;
  }

  /**
   * Добавлена проверка на modified, .т.к. при смене
   * "Нарушение не устранено" (потенциально и других полей), на значение
   * которое было изначально, состояние dirty для поля снимается, но остается
   * dirty для родительских зарегистрированных полей. При этом
   * wasEditWithoutViolationsFixed принимает состояние true.
   */
  const modifiedFields =
    modified &&
    Object.entries(modified)
      .filter(item => item[1] === true)
      .map(item => item[0].replaceAll(idRegex, '[{id}]'));

  // 1. Определяем, есть ли изменения в blackList полях
  const hasBlackListChanges = !!Object.keys(dirtyFields).find(i => {
    const regexpS = i.replaceAll(idRegex, '[{id}]');

    // Проверяем, что это поле есть в modified (отсеивает изменившиеся родительские блоки)
    const isInModifiedFields = !!modifiedFields?.find(item => item === regexpS);

    if (!isInModifiedFields) return false;

    return !!blackList.find(j => regexpS.indexOf(j) > -1);
  });

  // 2. Определяем, есть ли изменения в НЕ-blackList полях
  const hasNonBlackListChanges = !!Object.keys(dirtyFields).find(key => {
    const fieldNameTemplate = key
      .split('.')
      .map(item =>
        item.toLocaleLowerCase().indexOf('resultdecisions') === -1 ? item?.replace(idRegex, '[{id}]') : item,
      )
      .join('.');

    const regexpS = key.replaceAll(idRegex, '[{id}]');

    // Проверяем, что это поле есть в modified (отсеивает изменившиеся родительские блоки)
    const isInModifiedFields = !!modifiedFields?.find(item => item === regexpS);

    if (!isInModifiedFields) return false;

    // Проверяем, что это поле есть в fields
    const isInFields = !!fields.find(f => {
      const fieldNameInList = f.replace('[{id}]', `[${index}]`);

      return fieldNameInList === fieldNameTemplate;
    });

    if (!isInFields) return false;

    // Проверяем, что это поле НЕ в blackList
    const isBlackList = !!blackList.find(j => {
      return regexpS.indexOf(j) > -1;
    });

    return !isBlackList;
  });

  const wasEditWithoutViolationsFixed = !hasBlackListChanges;
  const wasEditFiled = hasBlackListChanges || hasNonBlackListChanges;

  // 3. Изменения ТОЛЬКО в blackList полях (без изменений в не-blackList)
  const wasEditOnlyViolations = hasBlackListChanges && !hasNonBlackListChanges;

  return {
    wasEditFiled,
    wasEditWithoutViolationsFixed,
    wasEditOnlyViolations,
  };
};

const blackList = [
  'violatedMandatory[{id}].violations[{id}].isFixed',
  'violatedMandatory[{id}].violations[{id}].isAppealed',
  'violatedMandatory[{id}].violations[{id}].repeatCorrected',
  'violatedMandatory[{id}].violations[{id}].repeatCorrectedInEvent',
  'violatedMandatory[{id}].violations[{id}].repeatExplanation',
  'violatedMandatory[{id}].violations[{id}].isViolationResolved',
  'violatedMandatory[{id}].violations[{id}].isViolationResolvedNote',
  'violatedMandatory[{id}].violations[{id}].fixPlanDates',
  'violatedMandatory[{id}].violations[{id}].fixPlanMethods',
  'violatedMandatory[{id}].violations[{id}].fixPlanExplanations',
  'violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'violatedMandatory[{id}].violations[{id}].fixes',
];

const fieldsKnm = [
  'resultDecisions[{id}].injunction.note',
  'resultDecisions[{id}].injunction.noteReactQuillEditor',
  'resultDecisions[{id}].fioSigner',
  'resultDecisions[{id}].titleSigner',
  'resultDecisions[{id}].violatedMandatoryRequirements',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].isFixed',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].isAppealed',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].explanation',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates[{id}].value',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethods',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethods[{id}].value',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations[{id}].value',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations[{id}].valueReactQuillEditor',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].grade',
  'resultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationGrade',
  'resultDecisions[{id}].familiarizationNotifications',
  'resultDecisions[{id}].familiarizationNotifications[{id}]',
  'resultDecisions[{id}].familiarizationNotifications[{id}].knmNoticeType',
  'resultDecisions[{id}].familiarizationNotifications[{id}].noticeDate',
  'resultDecisions[{id}].familiarizationNotifications[{id}].note',
];

const fieldsPm = [
  'pmResultDecisions[{id}].information',
  'pmResultDecisions[{id}].signerFullName',
  'pmResultDecisions[{id}].signerPosition',
  'pmResultDecisions[{id}].violatedMandatoryRequirements',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].isFixed',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].isAppealed',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].explanation',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates[{id}].value',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethods',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethods[{id}].value',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations[{id}].value',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations[{id}].valueReactQuillEditor',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].grade',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationGrade',
  'pmResultDecisions[{id}].familiarizationNotifications',
  'pmResultDecisions[{id}].familiarizationNotifications[{id}]',
  'pmResultDecisions[{id}].familiarizationNotifications[{id}].knmNoticeType',
  'pmResultDecisions[{id}].familiarizationNotifications[{id}].noticeDate',
  'pmResultDecisions[{id}].familiarizationNotifications[{id}].note',
];

const fieldsDecision = [
  'organization.resultDecisions[{id}].injunction.note',
  'organization.resultDecisions[{id}].injunction.noteReactQuillEditor',
  'organization.resultDecisions[{id}].fioSigner',
  'organization.resultDecisions[{id}].titleSigner',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].isFixed',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].isAppealed',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].explanation',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates[{id}].value',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethods',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethods[{id}].value',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations[{id}].value',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanations[{id}].valueReactQuillEditor',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'organization.resultDecisions[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].grade',
  '[{id}].eliminatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationGrade',
  'organization.resultDecisions[{id}].familiarizationNotifications',
  'organization.resultDecisions[{id}].familiarizationNotifications[{id}]',
  'organization.resultDecisions[{id}].familiarizationNotifications[{id}].knmNoticeType',
  'organization.resultDecisions[{id}].familiarizationNotifications[{id}].noticeDate',
  'organization.resultDecisions[{id}].familiarizationNotifications[{id}].note',
];
